module.exports = __webpack_public_path__ + "media/organizations/porsche-d5c607bf.svg";